import { render, staticRenderFns } from "./sender.vue?vue&type=template&id=0542f43a&scoped=true"
import script from "./sender.vue?vue&type=script&lang=js"
export * from "./sender.vue?vue&type=script&lang=js"
import style0 from "./sender.vue?vue&type=style&index=0&id=0542f43a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542f43a",
  null
  
)

export default component.exports